import React, { useState, useEffect, useContext } from "react";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";

import Icon1 from "../../images/theraicon1.svg";
import Icon2 from "../../images/theraicon2.svg";
import Icon3 from "../../images/theraicon3.svg";
import Icon4 from "../../images/dollar.svg";
import Icon5 from "../../images/clock.svg";

import { Link } from "react-router-dom";
import TherapistSidebar from "../../inc/TherapistSidebar";
import { FaAlignLeft } from "react-icons/fa";
import ApiService from "../../../utility/services/ApiService";
import { AuthContext } from "../../../utility/services/AuthContext";
import Functions from "../../../utility/services/Functions";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ConstConfig from "../../../utility/configs/constConfig";
import ImageConfig from "../../../utility/configs/imageConfig";
import CalenderIcon from "../../images/calender.svg";
import TimeIcon from "../../images/time.svg";
import UserAvatar from "../../common/UserAvatar";

const RequestAppointmentDetails = () => {
  // LOGICAL VARIABLES

  const { get_therapist_booking_details } = ApiService();
  const { setLoading } = useContext(AuthContext);
  const [initial_loading, setInitialLoading] = useState(false);
  const {
    consoleService,
    formet_date,
    formet_time,
    scheduledTimeForTherapist,
  } = Functions();
  const location = useLocation();
  const { booking_id, patient_id } = location.state ? location.state : {};

  const [filterHideShow, setfilterHideShow] = useState(false);

  // DATA VARIABLES

  const [currentBookingDetails, setCurrentBookingDetails] = useState({});
  const [pastBookingDetails, setPastBookingDetails] = useState([]);
  const isPastBookingsFound = pastBookingDetails.length > 0;

  // USE EFFECTS

  useEffect(() => {
    fetch_initial_details();
  }, []);

  // FUNCTIONS

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  async function fetch_initial_details() {
    setLoading(true);
    try {
      const res = await get_therapist_booking_details(booking_id, patient_id);
      if (res.status === 1) {
        const { current_boking_details, past_bookings } = res.data;
        setCurrentBookingDetails({ ...current_boking_details[0] });
        setPastBookingDetails([...past_bookings]);
        setInitialLoading(true);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch_initial_details", err);
    }
  }

  return (
    <>
      <div className="breadHidePhone">
        <BannerSection
          banner={Banner}
          name={"Home"}
          title={"Appointment Detail"}
        />
      </div>

      {Object.keys(currentBookingDetails).length ? (
        <section className="py-5 useraccount bg-light_dash detailsBox">
          <div className="container">
            <div className="row">
              <div
                className={`col-xl-3 col-md-4 ${
                  filterHideShow ? "leftShow" : "leftHide"
                }`}
              >
                <TherapistSidebar />
              </div>

              <div className="col-xl-9 col-md-8 fulltabBox request_appointment_details_fulltabBox">
                <div className="filterBox">
                  <Link className="filterIcon" onClick={sideBarHide}>
                    <FaAlignLeft />
                  </Link>
                </div>
                <div className="flexUser">
                  <div className="userDetails userDetails2">
                    <UserAvatar
                      profileImage={currentBookingDetails.patient_profile_img}
                      firstName={currentBookingDetails.patient_first_name || currentBookingDetails.patient_name}
                      lastName={currentBookingDetails.patient_last_name}
                      size="xl"
                      className="img-fluid thimg"
                      alt={`${currentBookingDetails.patient_name} profile`}
                    />
                    <div className="rightflex">
                      <div className="d-flex align-items-center">
                        <img
                          src={Icon1}
                          alt=""
                          className="img-fluid me-2 icc"
                        />
                        <h2 style={{ color: "black" }}>
                          {`${currentBookingDetails.patient_name} `}
                        </h2>
                      </div>

                      <div className="d-flex align-items-center mb-3 mt-1">
                        <img
                          src={Icon2}
                          alt=""
                          className="img-fluid me-2 icc"
                        />
                        <h3 className="mb-0 speciality_container_requset_detail">
                          {currentBookingDetails.speciality
                            .map((item) => item.trim())
                            .join(", ")}
                          .
                        </h3>
                      </div>

                      <div className="d-flex align-items-center mb-3 mt-1">
                        <img
                          src={Icon3}
                          alt=""
                          className="img-fluid me-2 icc"
                        />
                        <p className="mb-0">
                          {formet_date(currentBookingDetails.time)} |{" "}
                          {formet_time(currentBookingDetails.time)}
                        </p>
                      </div>

                      <div className="d-flex align-items-center mb-3 mt-1">
                        <img
                          src={Icon4}
                          alt=""
                          className="img-fluid me-2 icc"
                        />
                        <p className="mb-0">{currentBookingDetails.price}</p>
                      </div>

                      <div className="d-flex align-items-center mt-1">
                        <img
                          src={Icon5}
                          alt=""
                          className="img-fluid me-2 icc"
                        />
                        <p className="mb-0">
                          {scheduledTimeForTherapist(
                            currentBookingDetails.pricing,
                            currentBookingDetails.pricing_id
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <section className="py-5 specbox">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <h2 className="mb-3">Past Appointments</h2>
                        {initial_loading && (
                          <>
                            {isPastBookingsFound ? (
                              pastBookingDetails.map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="tabBox"
                                    style={{ marginBottom: 0 }}
                                  >
                                    <div className="docListitem">
                                      <div className="d-flex align-items-center">
                                        <UserAvatar
                                          profileImage={item.therapist_profile_img}
                                          firstName={item.therapist_first_name || item.therapist_name}
                                          lastName={item.therapist_last_name}
                                          size="md"
                                          className="imgDoc"
                                          alt={`${item.therapist_name} profile`}
                                        />
                                        <div className="l_content">
                                          <h2>
                                            <span className="uName_reverse_link">
                                              {`${item.therapist_name} `}
                                            </span>{" "}
                                          </h2>
                                          <p>
                                            {item.speciality
                                              .map((item) => item.trim())
                                              .join(", ")}
                                            .
                                          </p>
                                          <div className="timeflex">
                                            <img
                                              src={CalenderIcon}
                                              className="imgDoc"
                                              alt=""
                                            />
                                            <h4>
                                              {" "}
                                              {formet_date(item.time)} |{" "}
                                              {formet_time(item.time)}
                                            </h4>
                                            <div>
                                              <img
                                                src={TimeIcon}
                                                className="imgDoc"
                                                alt=""
                                              />
                                              <span>
                                                {scheduledTimeForTherapist(
                                                  item.pricing,
                                                  item.pricing_id
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div>No Data Found.</div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
};

export default RequestAppointmentDetails;
